export default __webpack_public_path__ + "static/media/f_a_t.838bda17.png";